




























import { Component, Prop, Vue } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import Modal from '@/main-components/common/modal/Modal.vue';

@Component({
  components: {
    MainButton,
    Modal,
  },
})
export default class ModalConfirm extends Vue {
  @Prop({ default: 'Title' })
  title: string;

  @Prop({ default: 'Description' })
  description: string;

  @Prop({ default: 'Confirm' })
  buttonLabel: string;

  @Prop({ required: true })
  onConfirmClick: () => Promise<void>;

  isLoading = false;
  openModalConfirm: any = null;
  closeModalConfirm: any = null;

  mounted() {
    this.$emit('openModalConfirmAdd', this.openModalConfirm);
  }

  async onConfirmClicked() {
    this.isLoading = true;
    await this.onConfirmClick();
    this.isLoading = false;
    this.closeModal();
  }

  closeModal() {
    this.closeModalConfirm && this.closeModalConfirm();
  }

  openModalAdd(openModal: any) {
    this.openModalConfirm = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModalConfirm = closeModal;
  }
}
